exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  font-family: sans-serif;\n  margin: 0;\n  padding: 0; }\n\nmain.container {\n  padding: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/index.scss
// module id = 172
// module chunks = 0